import { Suspense } from "react";
import HeaderWebsite from "../../components/HeaderWebsite";
import DashboardControl from "../../components/DashboardControl";

export default function DashboardPage(props) {
  const {
    statusMode,
    setStatusMode,
    isLoggedIn,
    showLogoutButton,
    notificationVolume,
    setNotificationVolume,
    userData,
  } = props;

  return (
    <>
      <HeaderWebsite
        statusMode={statusMode}
        setStatusMode={setStatusMode}
        isLoggedIn={isLoggedIn}
        showLogoutButton={showLogoutButton}
        notificationVolume={notificationVolume}
        setNotificationVolume={setNotificationVolume}
        userData={userData}
        user={userData}
      />
      <Suspense fallback={<div>Loading...</div>}>
        <DashboardControl
          statusMode={statusMode}
          setStatusMode={setStatusMode}
          isLoggedIn={isLoggedIn}
        />
      </Suspense>
    </>
  );
}
